export default __webpack_public_path__ + "static/media/rafa4.53e422c8.jpg";